export const VIDEO = 'VIDEO';
export const IMAGE = 'IMAGE';
export const AUDIO = 'APPLICATION';
export const APPLICATION = 'APPLICATION';

export const photoType = 'photo';
export const imageType = 'IMAGE';
